import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[appSafeHtml]',
  standalone: true,
})
export class SafeHtmlDirective implements OnInit {
  @Input() set appSafeHtml(html: string) {
    if (html) {
      // Extract image styles before insertion (before Angular sanitizes them)
      const imageStyles = this.extractImageStyles(html);
      
      // Insert HTML (styles will be stripped by Angular)
      this.elementRef.nativeElement.innerHTML = html;
      
      // Reapply image styles directly via JavaScript
      this.applyImageStyles(imageStyles);
    }
  }

  constructor(private elementRef: ElementRef) {}

  ngOnInit(): void {
    this.applyImageStylesFromAttributes();
  }

  private extractImageStyles(html: string): Map<string, string> {
    const styles = new Map<string, string>();
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    
    const images = tempDiv.querySelectorAll('img') as NodeListOf<HTMLImageElement>;
    images.forEach((img, index) => {
      const style = img.getAttribute('style');
      if (style) {
        styles.set(`img-${index}`, style);
        img.removeAttribute('style');
      }
    });
    
    return styles;
  }

  private applyImageStyles(imageStyles: Map<string, string>): void {
    const images = this.elementRef.nativeElement.querySelectorAll('img') as NodeListOf<HTMLImageElement>;
    let index = 0;
    images.forEach((img: HTMLImageElement) => {
      const styleStr = imageStyles.get(`img-${index}`);
      if (styleStr) {
        img.setAttribute('style', styleStr);
      }
      index++;
    });
  }

  private applyImageStylesFromAttributes(): void {
    const images = this.elementRef.nativeElement.querySelectorAll('img') as NodeListOf<HTMLImageElement>;
    images.forEach((img: HTMLImageElement) => {
      const style = img.getAttribute('style');
      if (style) {
        img.setAttribute('style', style);
      }
    });
  }
}

